
import { EFilter } from '@/helpers/enums'

export default {
  name: 'IncludeClosed',

  computed: {
    allByDefault() {
      return !this.$auth.user
    },

    closed: {
      get() {
        const queryParam = this.$route.query[EFilter.OPEN_ONLY]
        return queryParam ? !JSON.parse(queryParam) : this.allByDefault
      },
      async set(value) {
        this.$emit('before-update')

        if ((this.allByDefault && value) || (!this.allByDefault && !value)) {
          await this.$cleanQuery(this.$route.query, EFilter.OPEN_ONLY)
        } else {
          await this.$updateQuery(this.$route.query, {
            [EFilter.OPEN_ONLY]: JSON.stringify(!value)
          })
        }

        this.$emit('updated')
      }
    },

    items() {
      return [
        {
          id: 'includeClosed_1',
          value: false,
          text: this.$t('talent.project.search.include.closed.off')
        },
        {
          id: 'includeClosed_2',
          value: true,
          text: this.$t('talent.project.search.include.closed.on')
        }
      ]
    }
  },

  methods: {
    clearFilter() {
      this.$cleanQuery(this.$route.query, EFilter.OPEN_ONLY)
    }
  }
}
